import { useCallback } from 'react';

import { useAppDispatch } from '@/redux/hooks';
import { submitRecentSearch } from '@/redux/modules/saveSearch';
import { getSearchUrlWithParams } from '@/utils/urls';

export const useSubmitRecentSearch = () => {
    const dispatch = useAppDispatch();

    return useCallback(
        (keyword: string) => {
            const cleanedKeyword = keyword.trim();

            if (!cleanedKeyword) {
                return;
            }

            dispatch(
                submitRecentSearch({
                    saveSearchParams: { keyword: cleanedKeyword },
                    url: getSearchUrlWithParams({ keyword: cleanedKeyword }),
                })
            );
        },
        [dispatch]
    );
};
